import { RECEIVE_CALLUS_ERROR, RECEIVE_TOPIC_TREE_ERROR } from '../constants/ActionTypes';

const initialState = {
  isError: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RECEIVE_CALLUS_ERROR :
    case RECEIVE_TOPIC_TREE_ERROR:
      return Object.assign({}, state, { isError: action.payload ? !action.payload : true });
    default:
      return state;
  }
}
